import { render, staticRenderFns } from "./ProductDetailsApp.vue?vue&type=template&id=5ed3040b&scoped=true"
import script from "./ProductDetailsApp.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsApp.vue?vue&type=script&lang=ts"
import style0 from "./ProductDetailsApp.vue?vue&type=style&index=0&id=5ed3040b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3040b",
  null
  
)

export default component.exports